import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center hero-gradient px-4" data-testid="payment-cancel-page">
      <div className="bg-card border border-border rounded-2xl p-8 w-full max-w-md shadow-sm text-center">
        <XCircle className="h-10 w-10 mx-auto text-muted-foreground" />
        <h1 className="text-xl font-display font-semibold mt-4">Checkout canceled</h1>
        <p className="text-sm text-muted-foreground mt-2">No charge was made. You can pick a plan again whenever you're ready.</p>
        <Button className="mt-6 w-full" onClick={() => navigate("/settings?tab=billing")} data-testid="payment-cancel-back">Back to billing</Button>
      </div>
    </div>
  );
}
